// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageScrollContainer--DLk12 {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 20px;
  width: 100%;
  overflow: hidden;
}
.src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageScrollWrapper--VVNGN {
  width: max-content;
  overflow: hidden;
}
.src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__controlButton--gGNKb {
  border: none;
  box-shadow: none;
  background: none !important;
}
.src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__controlButton--gGNKb > div {
  display: none;
}
.src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageScroll--GfFsj {
  display: flex;
  align-items: center;
  column-gap: 10px;
  overflow-x: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;
  flex-shrink: 0;
  width: 100%;
}
.src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageScroll--GfFsj::-webkit-scrollbar {
  display: none;
}
.src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageScroll--GfFsj .src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageItem--yNIlG {
  height: 56px;
  width: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #0000000f;
  border-radius: 4px;
  padding: 4px;
  cursor: pointer;
  flex-shrink: 0;
}
.src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageScroll--GfFsj .src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageItem--yNIlG img {
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
}
.src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageScroll--GfFsj .src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageItem--yNIlG:hover:not(.src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageItemActive--E8oso):not(.src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageItemError--kGwas) {
  border-color: #595959;
}
.src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageScroll--GfFsj .src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageItemActive--E8oso {
  border-color: #e43d00;
}
.src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageScroll--GfFsj .src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageItemError--kGwas {
  border-color: #e9033a;
}
.src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageScroll--GfFsj .src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageItemErrorIcon--x5x_F {
  height: 30px;
  width: auto;
}
.src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageScroll--GfFsj .src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageItemErrorIcon--x5x_F svg {
  color: #e9033a;
  height: 100%;
  width: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/ImageCarousel/ImageCarouselScroll/ImageCarouselScroll.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AACF;AAEA;EACE,kBAAA;EACA,gBAAA;AAAF;AAGA;EACE,YAAA;EACA,gBAAA;EACA,2BAAA;AADF;AAGE;EACE,aAAA;AADJ;AAKA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,wBAAA;EACA,cAAA;EACA,WAAA;AAHF;AAKE;EACE,aAAA;AAHJ;AATA;EAgBI,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AAJJ;AArBA;EA4BM,mBAAA;EACA,eAAA;EACA,gBAAA;AAJN;AA1BA;EAmCI,qBAAA;AANJ;AA7BA;EAuCI,qBAAA;AAPJ;AAhCA;EA2CI,qBAAA;AARJ;AAnCA;EA+CI,YAAA;EACA,WAAA;AATJ;AAvCA;EAmDM,cAAA;EACA,YAAA;EACA,WAAA;AATN","sourcesContent":[".imageScrollContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  column-gap: 20px;\n  width: 100%;\n  overflow: hidden;\n}\n\n.imageScrollWrapper {\n  width: max-content;\n  overflow: hidden;\n}\n\n.controlButton {\n  border: none;\n  box-shadow: none;\n  background: none !important;\n\n  & > div {\n    display: none;\n  }\n}\n\n.imageScroll {\n  display: flex;\n  align-items: center;\n  column-gap: 10px;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  flex-shrink: 0;\n  width: 100%;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  .imageItem {\n    height: 56px;\n    width: 56px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid #0000000f;\n    border-radius: 4px;\n    padding: 4px;\n    cursor: pointer;\n    flex-shrink: 0;\n\n    img {\n      object-fit: contain;\n      max-width: 100%;\n      max-height: 100%;\n    }\n  }\n\n  .imageItem:hover:not(.imageItemActive):not(.imageItemError) {\n    border-color: #595959;\n  }\n\n  .imageItemActive {\n    border-color: #e43d00;\n  }\n\n  .imageItemError {\n    border-color: #e9033a;\n  }\n\n  .imageItemErrorIcon {\n    height: 30px;\n    width: auto;\n\n    svg {\n      color: #e9033a;\n      height: 100%;\n      width: auto;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imageScrollContainer": `src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageScrollContainer--DLk12`,
	"imageScrollWrapper": `src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageScrollWrapper--VVNGN`,
	"controlButton": `src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__controlButton--gGNKb`,
	"imageScroll": `src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageScroll--GfFsj`,
	"imageItem": `src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageItem--yNIlG`,
	"imageItemActive": `src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageItemActive--E8oso`,
	"imageItemError": `src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageItemError--kGwas`,
	"imageItemErrorIcon": `src-components-ImageCarousel-ImageCarouselScroll-ImageCarouselScroll-module__imageItemErrorIcon--x5x_F`
};
export default ___CSS_LOADER_EXPORT___;
